/*
 * https://github.com/5orenso
 *
 * Copyright (c) 2018 Øistein Sørensen
 * Licensed under the MIT license.
 */

'use strict';

// import 'highlight.js/styles/atom-one-dark.css';

const marked = require('marked');
// const hljs = require('highlight.js');

const renderer = new marked.Renderer();

// hljs.configure({
//     tabReplace: '    ', // 4 spaces
//     classPrefix: 'hljs-', // don't append class prefix
// });

// Markdown setup.
marked.setOptions({
    renderer,
    // highlight: (code, language) => {
    //     // console.log(code, language);
    //     // if (language) {
    //     //     return hljs.highlight(language, code).value;
    //     // }
    //     return hljs.highlightAuto(code).value;
    // },
    pedantic: false,
    gfm: true,
    tables: true,
    breaks: true,
    sanitize: false,
    smartLists: true,
    smartypants: true,
    xhtml: false,
});

renderer.heading = function heading(text, level) {
    const escapedText = text.toLowerCase().replace(/[^\w]+/g, '-');
    return `<h${level} class='toc-${level}'><a name='${
        escapedText
    }' class='anchor' href='#${
        escapedText
    }'><span class='header-link'></span></a>${
        text}</h${level}>`;
};

renderer.table = function table(header, body) {
    return `<table class='table table-striped table-hover'>
        <thead class='thead-dark'>${header}</thead>
        <tbody>${body}</tbody>
    </table>`;
};

renderer.blockquote = function blockquote(quote) {
    return `<blockquote class='blockquote text-muted ml-5'>
        <span class='display-4 float-left mr-4'>
            <i class="fas fa-quote-right"></i>
        </span>
        <p class='mb-0'>${quote}</p>
    </blockquote>`;
};

// renderer.code = function code(code, infostring, escaped) {
//     return `<pre>
//         <code class="language-${infostring} hljs rounded-lg">${
//             infostring ? hljs.highlight(infostring, code).value : hljs.highlightAuto(code).value
//         }</code>
//     </pre>`;
// };

renderer.image = function image($href, title, text) {
    if ($href.match(/youtube.com/)) {
        const regexp = /(^|[\s\t\n]+)https*:\/\/(www\.)*youtube\.com\/(.*?v=([^&\s]+)(&[^\s]+)*)/gi;
        const youtubeVideo = $href.replace(regexp, (match, p0, p1, p2, p3) => {
            return p3;
        });
        // <iframe class='embed-responsive-item' src='https://www.youtube.com/embed/${youtubeVideo}?rel=0' allowfullscreen  width='1900' height='1200'></iframe>
        return `
            <div class='youtube' data-embed='${youtubeVideo}'>
                <div class='play-button'></div>
                <img src='https://img.youtube.com/vi/${youtubeVideo}/sddefault.jpg'>
            </div>
            <div class='image_inline_text'><strong>${text || ''}</strong> ${title || ''}</div>
        `;
    }
    let serverName = '';
    if (document.domain === 'localhost' && !$href.match(/^http/)) {
        serverName = 'http://localhost:8080';
    }
    const src = `${serverName}${$href}`;
    const href = $href.replace(/(w=[0-9]+)/, 'w=1800');
    const mediaClass = [];
    const result = src.match(/#([a-z0-9,]+)$/);
    if (result) {
        const allClasses = result[1].split(',');
        if (allClasses[0] === 'card') {
            return `
                <div class='card float-right col-lg-4 col-md-6 col-sm-12 p-0 ml-2 mb-2 mt-2'>
                    <img class='card-img-top' src='${src}' alt='${title || text}'>
                    <div class='card-body'>
                        <h5 class='card-title'>${text || ''}</h5>
                        <p class='card-text'>${title || ''}</p>
                    </div>
                </div>`;
        }
        if (allClasses[0] === 'card2') {
            return `
                <div class='float-right card col-lg-7 col-md-7 col-sm-12 p-0 ml-2 mb-2 mt-2'>
                    <div class='row no-gutters'>
                        <div class='col-md-4'>
                            <img class='card-img img-fluid' src='${src}' alt='${title || text}'>
                        </div>
                        <div class='col-md-8'>
                            <div class='card-body'>
                                <h5 class='card-title'>${text || ''}</h5>
                                <p class='card-text'>${title || ''}</p>
                            </div>
                        </div>
                    </div>
                </div>
            `;
        }
        for (let i = 0, l = allClasses.length; i < l; i += 1) {
            mediaClass.push(allClasses[i]);
        }
    }
    return `
        <p class='image_inline ${mediaClass.join(' ')}'>
            <a href='${href}' data-smoothzoom='group1' title='${title || text}'>
                <img src='${src}' alt='${title || text}' title='${title || text}' class='img-fluid'>
            </a>
            <div class='font-weight-lighter'>
                <small>
                    <strong>${text || ''}</strong> ${title || ''}
                </small>
            </div>
        </p>`;
};

class Markdown {
    static render(data = '') {
        if (data) {
            const markdownData = marked(data.toString(), { renderer });
            return markdownData;
        }
        return '';
    }
}

export default Markdown;



// WEBPACK FOOTER //
// ./lib/markdown.js